export const UPCOMING_EVENTS = [
  {
    id: 0,
    name: 'Cat Yoga',
    image: '/assets/images/yoga-small.jpg',
    alt: 'Woman in yoga pose.',
    date: 'February 17',
    time: '6 - 8 PM',
    description:
      'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Porro ipsam voluptatem quae qui nam possimus quaerat quidem tempora adipisci perferendis. Et unde voluptatum dolor saepe quaerat consectetur minus, quisquam vitae placeat deserunt sit illum molestias.',
  },
  {
    id: 1,
    name: 'Knitting Night',
    image: '/assets/images/knitting.jpg',
    alt: 'Woman with Coffee cup and knitting project.',
    date: 'March 10',
    time: '6 - 8 PM',
    description:
      'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Porro ipsam voluptatem quae qui nam possimus quaerat quidem tempora adipisci perferendis. Et unde voluptatum dolor saepe quaerat consectetur minus, quisquam vitae placeat deserunt sit illum molestias.',
  },
  {
    id: 2,
    name: 'Book Club',
    image: '/assets/images/book-club.jpg',
    alt: 'Coffee and open book.',
    date: 'March 18',
    time: '6 - 8 PM',
    description:
      'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Porro ipsam voluptatem quae qui nam possimus quaerat quidem tempora adipisci perferendis. Et unde voluptatum dolor saepe quaerat consectetur minus, quisquam vitae placeat deserunt sit illum molestias.',
  },
]
